// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"f2e90602","600":"a334e160","677":"5fcf2186"}[chunkId] + ".chunk.js";
};